module.exports = __webpack_public_path__ + "static/media/adult-final.5e05a806.svg";